import Color from '../Color/Color'
import InvisiButton from '../InvisiButton/InvisiButton'
import classes from './TextArea.module.scss'
import { FiAlertCircle } from 'react-icons/fi'
import {
  type FormEvent,
  type ReactNode
} from 'react'

export interface Props {
  customValidity?: string|ReactNode
  isDisabled?: boolean // used for SpaceAccessControl disabled the Element
  isRequired?: boolean
  isInvalid?: boolean
  rows?: number
  maxHeight?: number
  maxLength: number
  onChange: (value: string) => void
  value: string
  placeholder?: string
  isReadOnly?: boolean
  minHeight?: number
  title?: string
  label?: string
  trailingIcon?: ReactNode
  hasClearButtonBackgroundColor?: boolean
  onSelect?: (event: FormEvent) => void
}

/* eslint-disable complexity */
const TextArea = ({
  customValidity,
  isDisabled,
  isRequired,
  isInvalid,
  rows = 2,
  isReadOnly,
  maxHeight,
  maxLength,
  minHeight = 30,
  onChange,
  title,
  label,
  placeholder,
  value,
  trailingIcon,
  hasClearButtonBackgroundColor = true,
  onSelect
}: Props) => {
  const handleChange = (event: FormEvent) => {
    const target = event.target as HTMLInputElement

    onChange(target.value)
  }

  const handleClear = () => {
    onChange('')
  }

  const style = maxHeight
    ? {
      maxHeight,
      minHeight
    }
    : { minHeight }

  const isInputDisableClass = isDisabled
    ? ' ' + classes.Disabled
    : ''

  const isInputReadonlyClass = isReadOnly
    ? ' ' + classes.Readonly
    : ''

  const isInputInvalidClass = isInvalid
    ? ' ' + classes.Invalid
    : ''

  const inputTextWrapperClass = classes.Layout + isInputDisableClass + isInputReadonlyClass + isInputInvalidClass

  return (
    <div className={classes.TextArea}>
      <div className={inputTextWrapperClass}>
        <textarea
          aria-label={label}
          disabled={isDisabled}
          maxLength={maxLength}
          onChange={handleChange}
          onSelect={onSelect}
          placeholder={placeholder}
          readOnly={isReadOnly} // only readonly style allow to drag and resize
          required={isRequired}
          rows={rows}
          style={style}
          title={title}
          value={value}
        />
        {
          trailingIcon &&
            <div className={classes.TrailingIcon}>
              {trailingIcon}
            </div>
        }
      </div>
      {
        value &&
          <div className={classes.LayoutSecondary}>
            {
              isInvalid && customValidity &&
                <div className={classes.ErrorMessage}>
                  <FiAlertCircle
                    aria-hidden
                    className={classes.ErrorIcon}
                    size='12px'
                  />
                  <span>{customValidity}</span>
                </div>
            }
            <div className={classes.Spacer} />
            {
              value && !isReadOnly && !isDisabled &&
                <div className={classes.ClearBtn}>
                  <InvisiButton
                    hasBackgroundColor={hasClearButtonBackgroundColor}
                    onClick={handleClear}
                    title='Clear'
                  >
                    <Color variant='theme-color-links'>
                      Clear
                    </Color>
                  </InvisiButton>
                </div>
            }
          </div>
      }

    </div>
  )
}
/* eslint-enable complexity */

export default TextArea
